import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useI18n } from "vue-i18n-bridge";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContestEntryFormStepper',
  props: {
    currentStep: { type: Number, required: true }
  },
  setup(__props: any) {



const { t } = useI18n();

const steps = computed(() => [
  { id: 1 as const, label: t("contestEntryForm.steps.applicantInfo") },
  { id: 2 as const, label: t("contestEntryForm.steps.selectWork") },
  { id: 3 as const, label: t("contestEntryForm.steps.confirm") },
]);

return { __sfc: true,t, steps }
}

})